import React, { useEffect, useState, useContext } from 'react';
import Style from "./index.module.css";
import { Link, useNavigate } from 'react-router-dom';
import { HiOutlineViewfinderCircle } from "react-icons/hi2";
import { UserContext } from '../../../Contexts/UserContext';
import authInstance from '../../../instance/AuthInstance';
import Star from '../../ReviewStars/Star';
import { toast } from 'react-toastify';
import { AiFillHeart } from 'react-icons/ai';
import { PiCurrencyInrBold } from "react-icons/pi";
import { FaRocket } from "react-icons/fa";
import { MdVerified } from "react-icons/md";

const ProductCard = ({ product }) => {
    const LoggedInUser = useContext(UserContext);
    const { User } = LoggedInUser;

    const Navigate = useNavigate();

    const [IsClicked, SetIsClicked] = useState(false);
    const [WishlistData, SetWishlistData] = useState([]);
    const [boostCount, setBoostCount] = useState(null);
    const [isBoosting, setIsBoosting] = useState(false);

    // Check if this product belongs to the logged-in user
    const isOwnProduct = product?.userId?._id === User?._id;

    //LoadCategory functions
    useEffect(() => {
        try {
            authInstance
                .get(`/api/user/wishlist/get_wishlist/${User?._id}`)
                .then((Response) => {
                    SetWishlistData(Response.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (error) {
            console.log(error);
        }
    }, [User]);

    // Fetch user's boost count
    useEffect(() => {
        if (User?._id && isOwnProduct) {
            authInstance
                .get(`/api/user/product/get_boost_count/${User._id}`)
                .then((response) => {
                    setBoostCount(response.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [User, isOwnProduct]);

    //check weather these product in wishlist
    const findItemId = () => {
        WishlistData.forEach((Data) => {
            const item = Data?.wishlist;
            const foundItem = item.find((item) => item?._id === product?._id);
            if (foundItem) {
                SetIsClicked(true);
            } else {
                SetIsClicked(false);
            }
        });
    };

    useEffect(() => {
        findItemId();
    }, [WishlistData]);

    const handleFavorite = (e) => {
        e.preventDefault();
        try {
            authInstance
                .post('/api/user/wishlist/add_wishlist', {
                    userId: User?._id,
                    productId: product?._id,
                })
                .then((Response) => {
                    toast.success("Product Added to Wishlist");
                    SetIsClicked(true);
                })
                .catch((err) => {
                    Navigate('/registration_login');
                    console.log(err);
                });
        } catch (error) {
            console.log(error);
        }
    };

    //Delete from wishlist
    const handleFavoriteDelete = (e) => {
        e.preventDefault();
        try {
            authInstance
                .delete(`/api/user/wishlist/remove_wishlist/${User?._id}/${product?._id}`)
                .then((Response) => {
                    toast.success("Product removed from Wishlist");
                    SetIsClicked(false);
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (error) {
            console.log(error);
        }
    };

    // ============ BOOST HANDLER ============
    const handleBoost = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!User?._id) {
            Navigate('/registration_login');
            return;
        }

        if (isBoosting) return; // Prevent multiple clicks

        setIsBoosting(true);

        try {
            const response = await authInstance.put(
                `/api/user/product/boost/${product._id}`
            );

            if (response.data.success) {
                toast.success("Product boosted successfully! 🚀");

                // Update boost count
                setBoostCount({
                    ...boostCount,
                    boostsRemaining: response.data.boostsRemaining,
                    usedBoosts: (boostCount?.usedBoosts || 0) + 1
                });

                // Refresh page to show updated sorting
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }
        } catch (error) {
            console.error(error);
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Failed to boost product");
            }
        } finally {
            setIsBoosting(false);
        }
    };
    // ============ END BOOST HANDLER ============

    const star = product?.userId?.totalrating ? product?.userId?.totalrating : "0";

    // Check if user can boost (has boosts remaining and it's their product)
    const canBoost = isOwnProduct && boostCount && boostCount.boostsRemaining > 0;

    // Check if seller is verified
    const isVerifiedSeller = product?.userId?.emailVerified && product?.userId?.phoneVerified;

    return (
        <div className={`${Style.products} ${isVerifiedSeller && !product?.isBoosted && !product?.boosted ? Style.verifiedProductCard : ''}`}>

            <div className={Style.productmedia}>
                {/* Boosted Badge (highest priority) */}
                {(product?.isBoosted || product?.boosted) && (
                    <span className={Style.boostedLabel}>
                        <FaRocket /> Recommended
                    </span>
                )}

                {/* Verified Badge */}
                {!(product?.isBoosted || product?.boosted) && !product?.featured && product?.userId?.emailVerified && product?.userId?.phoneVerified && (
                    <span className={Style.verifiedLabel}>
                        <MdVerified /> Verified Seller
                    </span>
                )}

                {/* Featured Badge (if not boosted) */}
                {!(product?.isBoosted || product?.boosted) && product?.featured && (
                    <span className={Style.productlabel}>Featured</span>
                )}

                <Link to={`/product/${product?._id}`}>
                    <img
                        src={product?.images[0].url}
                        alt="productImage"
                        className={Style.productImage}
                    />
                </Link>

                <div className={Style.productAction}>
                    <span
                        onClick={(e) =>
                            IsClicked ? handleFavoriteDelete(e) : handleFavorite(e)
                        }
                    >
                        <i style={{ color: IsClicked ? 'red' : 'grey' }}>
                            <AiFillHeart />
                        </i>{' '}
                        Favorite
                    </span>
                    <span onClick={() => Navigate(`/product/${product?._id}`)}>
                        <i>
                            <HiOutlineViewfinderCircle />
                        </i>{' '}
                        Explore
                    </span>
                </div>

                {/* Boost Button (only for own products) */}
                {isOwnProduct && !product?.isBoosted && (
                    <div className={Style.boostButtonContainer}>
                        {canBoost ? (
                            <button
                                className={Style.boostButton}
                                onClick={handleBoost}
                                disabled={isBoosting}
                            >
                                <FaRocket /> {isBoosting ? 'Boosting...' : 'Boost'}
                            </button>
                        ) : (
                            <div className={Style.noBoostsLeft}>
                                {boostCount?.boostsRemaining === 0 ? '0 Boosts Left' : 'Upgrade Plan'}
                            </div>
                        )}
                    </div>
                )}

                {/* Boost Count Indicator (for own products) */}
                {isOwnProduct && boostCount && (
                    <div className={Style.boostCountBadge}>
                        {boostCount.boostsRemaining}/{boostCount.maxBoosts} 🚀
                    </div>
                )}
            </div>

            <div className={Style.productbody}>
                <div className={Style.product_cat}>
                    <span> {product?.state} </span>
                </div>
                <div className={Style.product_title}>
                    <h3> {product?.title} </h3>
                </div>
                <div className={Style.product_price}>
                    <PiCurrencyInrBold /> {product?.price}
                </div>
                <div
                    className={Style.rating_container}
                    onClick={() => Navigate(`/clientprofile/${product.userId._id}`)}
                >
                    <div className={Style.rating}>
                        <Star stars={star} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductCard;